export function calculateAnstroemgeschwindigkeit({
  Volumenstrom,
  Schalldaempferbreite,
  Schalldaempferhoehe,
}) {
  let vStrom = parseFloat(Volumenstrom);
  let breite = parseFloat(Schalldaempferbreite);
  let hoehe = parseFloat(Schalldaempferhoehe);

  let vs = vStrom / (3600 * ((breite / 1000) * (hoehe / 1000)));
  return vs;
}

export function calculateSpaltgeschwindigkeit({
  Volumenstrom,
  Kulissenspaltbreite,
  Kulissenhoehe,
  AnzahlKulissen,
}) {
  let vStrom = parseFloat(Volumenstrom);
  let spalt = parseFloat(Kulissenspaltbreite);
  let kulissenhoehe = parseFloat(Kulissenhoehe);
  let anzahlKulissen = parseFloat(AnzahlKulissen);

  let vs = vStrom / (3600 * (spalt / 1000) * (anzahlKulissen) * (kulissenhoehe / 1000));
  return vs;
}
